import React, { useState } from 'react';
import { FaIcon } from '../../common/Icons.jsx';
import { Button } from '../../bootstrap/index.jsx';
import ImportWizardModal from './ImportWizardModal.jsx';

export default function ImportWizardButton({context, datagrid}) {
  const [openModal, setOpenModal] = useState(false);

  // handle onClose event of the modal
  const handleCloseModal = () => setOpenModal(false);

  // handle onClick event of the dropdown
  const handleClick = () => setOpenModal(true);

  return (<>
    <Button type='default' onClick={handleClick}>
      <FaIcon type='download'/>{I18n.t('import')}
    </Button>

    {openModal && <ImportWizardModal {...{handleCloseModal, context, datagrid}}/>}
  </>);
};